const select = (state) => state.organization

export const createGroupMembersCountSelector = (group_id) => (store) =>
  select(store).groups_data[group_id]?.members_count
